import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateRegEdSubmissions } from './useRegEdSubmissionsQuery';

/**
 * Renders the compliance PDF for the blog's open round. `ComplianceProviderGate` files nothing
 * without one, so a revision that skips this is never actually submitted — and says so to nobody.
 */
export const useRegEdBlogRegenerateCompliancePdfMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			blogPostId,
			impersonationContext,
		}: {
			blogPostId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `blog/${encodeURIComponent(blogPostId)}/regenerateCompliancePDF`,
				}),
				'POST',
				null
			),
		onError,
		onSuccess: (_, { blogPostId }) => {
			invalidateRegEdSubmissions(blogPostId);
			onSuccess?.();
		},
	});
};
